// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchInput_wrapper__3M7Fc","input":"SearchInput_input__3Qlab","clear":"SearchInput_clear__1wUIy","search":"SearchInput_search__iDJas"};